import { Injectable } from '@angular/core';
import { PendoServiceModel } from './models/pendo-service.model';
import { PendoEu } from './models/pendo.model';
import { TrackEventData } from './models/track-event.model';

@Injectable()
export class PendoEuService extends PendoServiceModel {
  constructor() {
    super();
  }

  getUserIdByEnvId(userId: string, envId: string): string {
    switch (envId) {
      case 'prod':
        return userId;
      case 'sales':
        return 'sales-' + userId;
      default:
        return 'dev-' + userId;
    }
  }

  initUser(userId: string, env: PendoEu.Account): void {
    const user = { id: this.getUserIdByEnvId(userId, env.id) };
    const account = { id: env.id, app: env.appName };
    this.initialize(user, account);
  }

  handelTrackEvent(trackEvent: TrackEventData<any>): void {
    if (!trackEvent) {
      return;
    }
    this.trackEvent(trackEvent.event, trackEvent.properties);
  }
}
